import React, { useEffect, useState, useMemo } from 'react';
import {
  defaultFormTemplate,
  directSchemaTemplate,
  columnLabels,
  fieldOverrides,
  validationRules,
  skipFields,
  infoIcons,
  layout
} from '../API/CategorySchema';
import { API_BASE_URL } from 'config';
import { useCategoryCreateStore } from '../store/useCategoryCreateStore';
import { fetchCustomFieldsByMenuId } from '@utils/customFields';
import PreBuildFormNew from '@components/form-elements/PreBuidFormNew';
import { fetchJson, useGetMetaData, useMatchedMenu } from '@utils/fetchJson';
import { toast } from 'react-toastify';
import CatColorPicker from '@components/form-elements/CatColorPicker';
import FormSkeleton from '@components/form-elements/FormSkeleton';
import { Dialog } from "@components/index";
import { Input } from '@components/index';
const CreateCategory = ({ onClose, onSave }) => {
  // This is used to get menuid from the module name /link
  const menuId = useMatchedMenu('category');
  // use this function to get the module metadata
  const  menuData = useGetMetaData('category');
  // This is use to open create module globally. Payload use to trasfer the data
  const { isOpen, short,form_label,payload: payloadWrapper, close } = useCategoryCreateStore();
  //const payload = payloadWrapper?.payload || payloadWrapper || {};
  const payload = useMemo(
  () => payloadWrapper?.payload || payloadWrapper || {},
  [payloadWrapper]
  );
  
  // use this to set default fields for the module
  const [defaultFormData, setDefaultFormData] = useState(defaultFormTemplate);
  const memoFormData = useMemo(() => defaultFormData, [defaultFormData]);
  // memorise the default data to rerender againa and again
  
  //Note: Merage all custom feilds with default
  const [mergedFieldOverrides, setMergedFieldOverrides] = useState(fieldOverrides);
  const [mergedValidationRules, setMergedValidationRules] = useState(validationRules);
  const [mergedColumnLabels, setMergedColumnLabels] = useState(columnLabels);
  const [mergedSchemaTemplate, setMergedSchemaTemplate] = useState(directSchemaTemplate);
  const [mergedLayout, setMergedLayout] = useState(layout);
  const [customFields, setCustomFields] = useState([]);
  const [initialData, setInitialData] = useState(false);
  const rawLabel = payload?.form_label ?? '';
  const cleanLabel = rawLabel
    .replace(/select(\.{3}|…)/gi, '') // remove "Select..." or "Select…"
    .trim()
    .replace(/^[\-\–\:]+/, '')        // drop leading separators if any
    .trim();

  // use this to overrite any feild
  const customeModules ={
    CatColorPicker: () => <CatColorPicker label="Tag Color" defaultColor={defaultFormData.cat_color} onSelect={(color )=>{
      setDefaultFormData((prev) => {
        return {...prev, cat_color: color,};
      });
    }} />
  }
  // use this to set default data and edit record data.
  useEffect(() => {
    const setupFormData = async () => {
      // 1. Editing existing record
      if (payload?.record_id) {
        setInitialData(false);
        try {
          const res = await fetchJson(`${API_BASE_URL}/categoryMaster/${payload.record_id}?menuId=${menuId}`, {
            method: 'GET',
          });
          const recordData = res?.data?.[0] || {};
          setDefaultFormData(prev => ({...prev,...payload,...recordData,menuId,}));
        } catch (err) {
          setDefaultFormData(prev => ({...prev,...payload, menuId }));
        }
        setInitialData(true);
      }
      else {
        // 2. Creating new record
        setDefaultFormData(prev => ({...prev,...payload, menuId }));
        setInitialData(true);
        
      }
    };
    setupFormData();
  }, [payload, menuId]);
// this useEffect use to get all the dynamic and statis fields from the server and update default values 
useEffect(() => {
  if (!isOpen || !menuId) return;

  const loadFields = async () => {
    try {
      const {
        injectedLayout,
        customFields,
        extendedDefaults,
        extendedValidations,
        extendedLabels,
        extendedOverrides,
        extendedSchema,
        generatedLayout
      } = await fetchCustomFieldsByMenuId(menuId, menuData, {
        defaultFormTemplate,
        validationRules,
        fieldOverrides,
        columnLabels,
        directSchemaTemplate,
        layout,
        autoInjectLayout: true,
      });

      setCustomFields(customFields);
      setMergedValidationRules(extendedValidations);
      setMergedColumnLabels(extendedLabels);
      setDefaultFormData(prev => ({
        ...extendedDefaults,
        ...prev,
      }));
      setMergedFieldOverrides(extendedOverrides);
      setMergedSchemaTemplate(extendedSchema);
      setMergedLayout(injectedLayout);
    } catch (err) {
      toast.error('Failed to load custom fields');
    }
  };
  loadFields();
}, [isOpen, menuId, menuData, payload?.parent_id, payload?.is_parent]);
const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetchJson(`${API_BASE_URL}/categoryMaster`, {
        method: "PUT",
        body: JSON.stringify(defaultFormData),
      });
      const ok = res?.flag === "S" || res?.statusCode === 200;
      if (ok) {
        toast.success(`${payload?.form_label} Created`);
         setDefaultFormData(defaultFormTemplate); close(res);
      } else {
         toast.error(`Error (${res.msg})`);
      }
    } catch {
      //setError("Server error while saving payment.");
    }
  };

// use this to create slug
function slugify(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_') 
    .replace(/[^\w_]/g, '');
}
const updateData = (updater) => {
  setDefaultFormData(prev => {
    // If updater is a function, call it (React state API)
    const next = typeof updater === 'function' ? updater(prev) : updater;

    // If cat_name has changed, update slug
    if (next.categoryName !== prev.categoryName) {
      return {
        ...next,
        slug: slugify(next.categoryName)
      };
    }
    return next;
  });
};
const closeDailog =()=>{
  setDefaultFormData(prev => ({...prev,...payload,categoryName:""})); close?.();
  
}
  if (!isOpen) return null;
  const loading = payload?.record_id && !initialData;
  
  // PreBuildFormNew use to create form for the module.
  /*
  * directSchema : used to show form feilds
  * getDefApi this is used to get the datatabel feilds details like name,type default value etc.
  * saveApi : this is used to save the data
  * updateApi : use to update the record.
  * formDataPre: this is the form data
  * primaryKey: this identified the which is the primary key for module.
  * sidebarSize : this is used to define the module sixe. lg is large. md is medium
  * title : this is used to show the from title
  * onClose : do action on close.
  * skipFields : this is used to skip the feilds.
  * fieldOverrides : if you want to add new module or override any filed behaviour use this.
  * validationRules : add form validation
  * labels: if you want to override the lable use this.
  * editId : this is used to identified the edit key
  * recordId: this is used to identified the primary key.
  */
  return (
    <>
  {loading ? (
    <div className="modal-panel size-lg fixed top-[50px] right-0 h-[calc(100vh-56px)] bg-white shadow-lg z-50 flex flex-col w-screen max-w-full md:w-[700px]">
      <FormSkeleton />
    </div>
  ) : payload?.short ? (
    <Dialog
      open={true}              // or: open={Boolean(payload?.short)}
      isOpen={true}            // keep if your Dialog supports both
      onClose={closeDailog}          // <-- must be a function, not just `onClose`
      variant="custom"
      size="sm"
      title="Create Category"
    >
      {/* Header */}
      <div className="sticky top-0 bg-white px-5 pt-4 pb-3 border-b z-10">
        <h3 className="text-lg font-semibold">{`Create New ${cleanLabel ? ` ${cleanLabel}` : ''}`}</h3>
      </div>
      {/* Body */}
      <div className="p-5">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          {/* Transaction ID */}
          <div>
            {/* <label className="text-xs text-slate-600">Name</label> */}
            <Input
              type="text"
              value={defaultFormData.categoryName}
              onChange={(e) =>{
                const cName = e.target.value;
                setDefaultFormData(prev => ({...prev,...payload, slug: slugify(cName),categoryName:cName}))}}
              //onChange={(e) => setForm((f) => ({ ...f, amount: e.target.value }))}
              placeholder="Enter Name"
              required
            />
          </div>
          <div className="sticky bottom-0 bg-white pt-3 pb-2 border-t -mx-5 px-5 flex justify-end gap-2">
            <button onClick={closeDailog} className="text-sm px-3 py-1 rounded border">Cancel</button>
              <button type="submit" onClick={(e) => handleSubmit?.(e)} className="bg-blue-600 text-white px-4 py-1 rounded hover:bg-blue-700 text-sm">Save</button>
          </div>
        </div>
      </div>
    </Dialog>
  ) : (
    <PreBuildFormNew
      menuId={menuId}
      directSchema={mergedSchemaTemplate}
      getDefApi={`${API_BASE_URL}/getDefinations`}
      saveApi={`${API_BASE_URL}/categoryMaster`}
      updateApi={`${API_BASE_URL}/categoryMaster/${memoFormData?.category_id}`}
      formData={defaultFormData}
      setFormData={updateData}
      primaryKey="category_id"
      sidebarSize="lg"
      title="Create Category"
      onClose={(res) => { setDefaultFormData(defaultFormTemplate); close(res); }}
      skipFields={skipFields}
      fieldOverrides={mergedFieldOverrides}
      validationRules={mergedValidationRules}
      labels={mergedColumnLabels}
      infoIcons={infoIcons}
      layout={mergedLayout}
      editId={memoFormData?.category_id}
      recordId={memoFormData?.category_id}
      customModules={customeModules ? customeModules : {}}
    />
  )}
</>

  
  );
};
export default CreateCategory;